import React, { useState } from 'react';
import PlusSmall from '@uber/base-icons/plus-small';
import TrashCan from '@uber/base-icons/trash-can';
import X from '@uber/base-icons/x';
import { Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { LabelMedium } from 'baseui/typography';
import { FeedbackList } from './feedback-list';
import { ButtonContainer, SectionHeader, SubContainer } from './styled-components';
type Props = {
  title: string;
  list: {
    label: string;
    description: string;
  }[];
  onAddFeedback: () => void;
  onEditFeedback: (index: number) => void;
  onDeleteFeedback: (indicesToDelete: number[]) => void;
};
export const FeedbackSubSection = ({
  title,
  list,
  onAddFeedback,
  onEditFeedback,
  onDeleteFeedback
}: Props) => {
  const [isDeleteMode, setIsDeleteMode] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const handleEnterDeleteMode = () => {
    setIsDeleteMode(true);
    setSelectedItems(new Set());
  };
  const handleExitDeleteMode = () => {
    setIsDeleteMode(false);
    setSelectedItems(new Set());
  };
  const handleItemSelect = (index: number) => {
    const newSelected = new Set(selectedItems);
    newSelected.has(index) ? newSelected.delete(index) : newSelected.add(index);
    setSelectedItems(newSelected);
  };
  const handleDelete = () => {
    if (selectedItems.size > 0) {
      onDeleteFeedback(Array.from(selectedItems));
      setSelectedItems(new Set());
      setIsDeleteMode(false);
    }
  };
  return <SubContainer>
      <SectionHeader>
        <LabelMedium>{title + ` (${list.length})`}</LabelMedium>
        <ButtonContainer>
          <Button kind={isDeleteMode ? KIND.primary : KIND.secondary} shape={SHAPE.square} size={SIZE.mini} onClick={isDeleteMode ? handleDelete : handleEnterDeleteMode} data-testid="delete-button">
            <TrashCan />
          </Button>
          {isDeleteMode && <Button kind={KIND.secondary} shape={SHAPE.square} size={SIZE.mini} onClick={handleExitDeleteMode} data-testid="exit-delete-mode-button">
              <X />
            </Button>}
          <Button kind={KIND.secondary} size={SIZE.mini} endEnhancer={<PlusSmall />} onClick={onAddFeedback} data-testid="add-button">
            Add
          </Button>
        </ButtonContainer>
      </SectionHeader>
      <FeedbackList list={list} isDeleteMode={isDeleteMode} selectedItems={selectedItems} onItemSelect={handleItemSelect} onEditFeedback={onEditFeedback} />
    </SubContainer>;
};